var WooNotices = {
	init:function(){
		
		$(window).resize(function(){
			WooNotices.resize();
		});
		WooNotices.resize();
		
		$(".woocommerce-notices-wrapper .btn-close").on("click touchend", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}
			$(".woocommerce-notices-wrapper").addClass("hidden");
			$(".woocommerce-notices-wrapper.hidden").css({bottom:(-1 * $(".woocommerce-notices-wrapper").outerHeight())});
		})
	},
	resize:function(){
		$(".woocommerce-notices-wrapper.hidden").css({bottom:(-1 * $(".woocommerce-notices-wrapper").outerHeight())});
	}
}

$(window).load(function(){
	if($(".woocommerce-notices-wrapper .btn-close").length){
		WooNotices.init();
	}
})